import querystring from 'querystring'
import ApiService from './ApiService'

const resourceUrl = `${ApiService.prefix}rest/data/geo/polygon`

export default {
  getPolylines(parentAttribute, parentId) {
    const params = {
      parentAttribute,
      parentId,
    }
    return ApiService.get(`${resourceUrl}/polylines?${querystring.stringify(params)}`)
  },
}
